import { saveCommandingOptions } from "./saveCommandingOptions";
import type { CommandingViewMode } from "owa-outlook-service-option-store";

export function saveCommandingViewModeOption(viewMode: CommandingViewMode): void {
    saveCommandingOptions({ viewMode });
}
